import { atomWithReset } from "jotai/utils";
import { getDefaultComponentsState } from "./defaultComponentsState";

export const defaultComponentsAtom = atomWithReset(getDefaultComponentsState());
